// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon__icon--GBxm0 {
    display: inline-flex;
    padding: 0;
}

    .Icon__icon--GBxm0.Icon__clicked--FnRLU {
        cursor: pointer;
    }

    .Icon__icon--GBxm0.Icon__light--CwjYI > svg > path {
        stroke: var(--tertiary-color);
    }
`, "",{"version":3,"sources":["webpack://./src/components/Icon/Icon.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,UAAU;AASd;;IAPI;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC","sourcesContent":[".icon {\n    display: inline-flex;\n    padding: 0;\n\n    &.clicked {\n        cursor: pointer;\n    }\n\n    &.light > svg > path {\n        stroke: var(--tertiary-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Icon__icon--GBxm0`,
	"clicked": `Icon__clicked--FnRLU`,
	"light": `Icon__light--CwjYI`
};
export default ___CSS_LOADER_EXPORT___;
